var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"modal-header\"><h3>{{modalOptions.headerText}}</h3></div><div class=\"modal-body\"><p>{{modalOptions.bodyText}}</p></div><div class=\"modal-footer\"><button type=\"button\" ng-click=\"modalOptions.close()\" class=\"btn btn-default\">{{modalOptions.closeButtonText}}</button><button type=\"button\" ng-click=\"modalOptions.ok()\" class=\"btn btn-primary\">{{modalOptions.actionButtonText}}</button></div>");;return buf.join("");
}

module.exports = module.exports.apply(module, [])


//////////////////
// WEBPACK FOOTER
// ./~/apply-loader!./app/common/tmModalSvc.jade
// module id = 324
// module chunks = 0